import { useMemo } from 'react';

const createGateError = ({ message, status = 0, method = 'GET', url = '' }: { message: string; status?: number; method?: string; url?: string }) =>
  Object.assign(new Error(message), { status, method, url });

export function useRealApiReadinessGate({
  enabled = false,
  apiBaseUrl = '',
} = {}) {
  const normalizedApiBaseUrl = String(apiBaseUrl || '').trim();

  return useMemo(() => {
    const error = enabled && !normalizedApiBaseUrl
      ? createGateError({ message: '' })
      : null;
    return {
      checking: false,
      ready: !error,
      error,
      blocked: Boolean(error),
    };
  }, [enabled, normalizedApiBaseUrl]);
}
